import { getMsgFromApiErr } from "@api/api";
import useRequestState from "@hooks/useRequestState";
import { useCallback, useEffect } from "react";
import getUnreadNotifications, { UnreadNotification } from "../getUnreadNotifications";

const useGetUnreadNotifications = (autoSend?: boolean) => {
  const { reqState, setLoading, setSuccess, setError } = useRequestState<UnreadNotification[]>([]);

  const send = useCallback(async () => {
    setLoading();
    try {
      const notifications = await getUnreadNotifications();
      return setSuccess(notifications);
    } catch (err: any) {
      return setError(getMsgFromApiErr(err));
    }
  }, [setError, setLoading, setSuccess]);

  useEffect(() => {
    if (autoSend) send();
    // prevents infinite loop
    // eslint-disable-next-line
  }, [autoSend]);

  return { ...reqState, data: reqState.data, send };
};

export default useGetUnreadNotifications;
